import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconUser$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconUser extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'ab22917583b249322900428c8e295154257a8709', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '2136d00723909f96dbc082761a231bb1ccbe1312', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '5ffdd351a22728d5e3902b272b1f53de89d37783', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11.006 13.75a3.61 3.61 0 0 1-3.659-3.398l-.295-2.606a3.95 3.95 0 0 1 .86-3.188 4 4 0 0 1 3.094-1.308A4 4 0 0 1 14.1 4.56a3.95 3.95 0 0 1 .857 3.206l-.292 2.588a3.614 3.614 0 0 1-3.66 3.396m0-9a2.53 2.53 0 0 0-1.961.791 2.48 2.48 0 0 0-.505 2.016l.298 2.627a2.172 2.172 0 0 0 4.338.001l.295-2.608a2.5 2.5 0 0 0-.502-2.034 2.54 2.54 0 0 0-1.963-.793m4.161 9.854a6.09 6.09 0 0 1 2.838 4.866.506.506 0 0 1-.501.53H4.509a.506.506 0 0 1-.502-.53 6.09 6.09 0 0 1 2.838-4.866.49.49 0 0 1 .701.102l.311.347a.416.416 0 0 1-.11.704 5 5 0 0 0-2.055 2.713H16.31a4.94 4.94 0 0 0-2.055-2.713.415.415 0 0 1-.1-.704l.31-.347a.49.49 0 0 1 .702-.102", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-user", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-user"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-user":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconUser$1);
            }
            break;
    } });
}

const CosmosIconUser = CosmosIconUser$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconUser, defineCustomElement };
